import React, { useEffect, useState } from 'react'
import {
  StyledTab,
  SubmitFlex,
  MenuFlex,
} from 'modules/Roles/Partials/RolesInfoTable/Style/style'
import FilterDiv from 'components/FilterDiv'
import Button from 'components/Button'
import JobTypeFilter from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/JobTypeFilter'
import StatusFilter from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/StatusFilter'
import HireFilter from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/HiresFilter'
import LocationFilter from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/LocationFilter'
import SalaryFilter from 'modules/Roles/Partials/RolesInfoTable/Partials/RoleFilter/Partials/SalaryFilter'

const { TabPane } = StyledTab

const RoleFilter = ({ setQuery, citiesList, getCities, selectionType, urlQuery }) => {
  const [filters, setFilters] = useState({})
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [flag, setFlag] = useState(false)
  const [jobTypeValue, setJobTypeValue] = useState([])
  const [statusValue, setStatusValue] = useState([])
  const [hireValue, setHireValue] = useState([])
  const [location, setLocation] = useState([])

  useEffect(() => {
    setFilters([])
    setJobTypeValue([])
    setStatusValue([])
    setHireValue([])
    setLocation([])
  },[selectionType])
  const onJobTypeChange = status => {
    if (status.length) {
      setJobTypeValue([status[status.length - 1]])
      let jobType = status[status.length - 1]
      if (jobType == 'FULL_TIME' || jobType === 'PART_TIME') {
        setFilters(prev => {
          return { ...prev, jobType: status[status.length - 1] }
        })
      } else {
        setFilters(prev => {
          return { ...prev, jobTypeLevel: status[status.length - 1] }
        })
      }
    } else {
      setJobTypeValue([])
      let filterCopy = { ...filters }
      if (filterCopy?.jobType) {
        delete filterCopy.jobType
      } else {
        delete filterCopy.jobTypeLevel
      }
      setFilters(filterCopy)
    }
  }
  const onStatusChange = status => {
    if (status?.length) {
      status = status?.[status?.length - 1]
      setStatusValue([status])
      setFilters(prev => {
        return { ...prev, status }
      })
    } else {
      setStatusValue([])
      let filterCopy = { ...filters }
      if (filterCopy?.status) {
        delete filterCopy?.status
      }
      setFilters(filterCopy)
    }
  }

  const onHireValueChange = status => {
    if (status.length) {
      let minVacancies = [];
      let maxVacancies = [];
  
      status.forEach(val => {
        let range = val.split('-');
        minVacancies.push(range[0]);
        maxVacancies.push(range[1]);
      });
  
      setHireValue(status);
      setFilters(prev => ({
        ...prev,
        minVacancies: Math.min(...minVacancies), 
        maxVacancies: Math.max(...maxVacancies), 
      }));
    } else {
      setHireValue([]);
      let filterCopy = { ...filters };
      delete filterCopy.maxVacancies;
      delete filterCopy.minVacancies;
      setFilters(filterCopy);
    }
  };
  
  const onLocationChange = location => {
    if (location.length) {
      setLocation(location)
      setFilters(prev => {
        return { ...prev, cities: location }
      })
    } else {
      setLocation([])
      let filterCopy = { ...filters }
      delete filterCopy.cities
      setFilters(filterCopy)
    }
  }

  const submitFilter = () => {
    let queryParams = ''
    Object.keys(filters).forEach(val => {
      queryParams = `${queryParams}${val}=${filters[val]}&`
    })
    queryParams = queryParams.substring(0, queryParams.length - 1)
    setQuery(queryParams)
    setIsMenuOpen(false)
    setFlag(true)
  }
  const menu = (
    <MenuFlex column>
      <StyledTab border={true} tabPosition={'left'} type="card">
        <TabPane tab="Job Type" key="1">
          <JobTypeFilter setJobType={onJobTypeChange} value={jobTypeValue} />
        </TabPane>
        <TabPane tab="No of Hires" key="2">
          <HireFilter setHire={onHireValueChange} value={hireValue} />
        </TabPane>
        <TabPane tab="Location" key="3">
          <LocationFilter
            setLocation={onLocationChange}
            citiesList={citiesList}
            getCities={getCities}
            value={location}
            location={location}
            setFlag={setFlag}
            flag={flag}
          />
        </TabPane>
        <TabPane tab="Salary" key="4">
          <SalaryFilter setFilters={setFilters} filters={filters} currentUrl={urlQuery} />
        </TabPane>
        {selectionType != 'AcceptedRoles' && (
          <TabPane tab="Status" key="5">
            <StatusFilter setStatus={onStatusChange} value={statusValue} />
          </TabPane>
        )}
      </StyledTab>
      <SubmitFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setIsMenuOpen(false)
            setFlag(true)
            // Reset all filter values to their applied state (revert temporary changes)
            setLocation([])
            setJobTypeValue([])
            setStatusValue([])
            setHireValue([])
          }}
        />
        <Button.Primary text="Apply Filter" onClick={submitFilter} />
      </SubmitFlex>
    </MenuFlex>
  )

  return (
    <FilterDiv
      overlayMenu={menu}
      open={isMenuOpen}
      setOpen={flag => {
        setIsMenuOpen(flag)
      }}
    />
  )
}

export default RoleFilter
